import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectCadastralNumbers } from '../../../selectors/offer/selectCadastralNumbers';
import { selectCadastralFieldsMeta } from '../../../selectors/rosreestrData';
import { ECadastralFieldsNames } from '../../../types/reducers/rosreestrData';
import { trackLandFieldSubmit } from '../tracking';
import { IAngularProps } from '../types';
import { getError } from '../utils/getError';

interface IParams extends Pick<IAngularProps, '$rootScope'> {
  validateField: (
    name: ECadastralFieldsNames,
    value: string,
    isSubmitted?: boolean,
  ) => { name: ECadastralFieldsNames; value: string };
  setShowNoCadastralNumberButton(value: boolean): void;
}

/** Валидация полей при отправке формы */
export const useValidateOnSubmit = ({ $rootScope, validateField, setShowNoCadastralNumberButton }: IParams) => {
  const dispatch = useDispatch();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const cadastralNumbers = useSelector(selectCadastralNumbers, shallowEqual);
  const cadastralFieldsMeta = useSelector(selectCadastralFieldsMeta);

  useEffect(() => {
    const removeListener = $rootScope.$on('addform.submit', () => {
      Object.entries(cadastralNumbers).map(entry => {
        const [key, value] = entry as [ECadastralFieldsNames, string];

        validateField(key, value);

        /** Отправляем только для кадастрового номера участка */
        if (key === ECadastralFieldsNames.CadastralNumber) {
          trackLandFieldSubmit(cadastralFieldsMeta[key].isRequired, value);
        }
      });

      setIsSubmitted(true);
    });

    return () => {
      removeListener();

      setIsSubmitted(false);
    };
  }, [$rootScope, cadastralFieldsMeta, cadastralNumbers, dispatch, validateField]);

  useEffect(() => {
    const { errors, isRequired } = cadastralFieldsMeta[ECadastralFieldsNames.CadastralNumber];
    const { cadastralNumber: landNumber } = cadastralNumbers;

    if (isSubmitted && isRequired && getError(errors, landNumber)) {
      setShowNoCadastralNumberButton(true);
    }
  }, [isSubmitted, cadastralFieldsMeta, cadastralNumbers, setShowNoCadastralNumberButton]);
};
